import { render, staticRenderFns } from "./AnimatorsListDialog.vue?vue&type=template&id=115332c8&scoped=true&"
import script from "./AnimatorsListDialog.vue?vue&type=script&lang=js&"
export * from "./AnimatorsListDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "115332c8",
  null
  
)

export default component.exports